import * as React from "react"

import { useBounceGlobalValues, useTranslation } from "@bounce/i18n"
import { CTA } from "@bounce/web-components"

import type { CityData } from "../../../../libs/bounce/types"
import type { FormattedEvent } from "../../../../libs/prismic/types"
import { useUrl } from "../../../../libs/router"
import { goToApp, useAppURL } from "../../../../utils/appURL"

export type BookNowProps = {
  event: FormattedEvent
  city: CityData
  className?: string
}

export const BookNow = ({ event, city, className }: BookNowProps) => {
  const { t } = useTranslation("marketing-ls-event")
  const bounceGlobals = useBounceGlobalValues()
  const { getUrl } = useUrl()
  const buildAppURL = useAppURL()

  const url = buildAppURL(getUrl({ path: "/s" }), { query: event.address, coupon: event.couponCode })
  const onClickCta = () => goToApp(url, { cta: "BookNowEvent" })

  return (
    <CTA
      title={t("screen.event.bookNowTitleV3", "Store your bags with Bounce")}
      subtitle={t("screen.event.bookNowSubtitle", "In {{cityName}} and {{numCities}}+ cities worldwide", {
        cityName: city.translatedName,
        numCities: bounceGlobals.numCities,
      })}
      ctaLabel={t("screen.event.bookNowCta1", "Find closest locations")}
      ctaOnClick={onClickCta}
      ctaHref={url}
      ctaRel="nofollow"
      className={className}
    />
  )
}
